import { Link, useParams } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { SpinnerIcon } from '@/components/ui/SpinnerIcon'
import { AdminUserInfoCard } from '@/components/admin/AdminUserInfoCard'
import { AdminFeatureFlagsCard } from '@/components/admin/AdminFeatureFlagsCard'
import { AdminSubscriptionCard } from '@/components/admin/AdminSubscriptionCard'
import { useAdminUser } from '@/hooks/admin/useAdminUser'

export function AdminUserDetailPage() {
  const { uid } = useParams<{ uid: string }>()
  const { user, loading, error, reload } = useAdminUser(uid)

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <SpinnerIcon size="lg" className="text-blue-600" />
      </div>
    )
  }

  if (error || !user) {
    return (
      <div className="space-y-4">
        <BackLink />
        <p className="text-destructive py-8">
          {error ?? 'Användaren hittades inte'}
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div>
        <BackLink />
        <h1 className="text-2xl font-bold mt-2">
          {user.companyName || user.email}
        </h1>
        <p className="text-muted-foreground">{user.email}</p>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <AdminUserInfoCard user={user} />
        <div className="space-y-6">
          <AdminFeatureFlagsCard user={user} onSaved={reload} />
          <AdminSubscriptionCard user={user} onSaved={reload} />
        </div>
      </div>
    </div>
  )
}

function BackLink() {
  return (
    <Link
      to="/admin"
      className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
    >
      <ArrowLeft className="h-4 w-4" />
      Tillbaka till användarlistan
    </Link>
  )
}
